import React from "react"
import Select from 'react-select';

class SelectDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listOpen: false,
            title: ""
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
      }
    
      componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    
    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                listOpen: false
            })
        }
      }

    toggleList = () => {
        if (!this.props.disabled) {
            this.setState(prevState => ({
                listOpen: !prevState.listOpen
            }))
        }
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    }

    render() {
        const { options=[], disabled, value, callBack, attachToBody=false, onFocus=()=>{}, onBlur=()=>{}, noBorderBottom = false, extraStyles = null } = this.props;
        const menuPortalTarget = (typeof window !== "undefined" && attachToBody ? document.body : null );
        var selectedValue = options.find(x => x.id === value || x === value);
        selectedValue = selectedValue && (selectedValue.id ? selectedValue : {id: selectedValue, text: selectedValue});
        return (
            <>
            <Select
                value={selectedValue}
                options={options}
                getOptionLabel={(option)=>option.text || option}
                getOptionValue={(option)=>option.id || option}
                onChange={callBack}
                isDisabled={disabled}
                isOptionDisabled={(option)=>option.disabled}
                menuPortalTarget={menuPortalTarget}
                onFocus={onFocus}
                onBlur={onBlur}
                styles={
                    {
                        container: (provided,state) => ({
                            ...provided,
                            width: '100%',
                            borderBottom: noBorderBottom ? undefined : '1px solid #E4E4E4',
                            ...(extraStyles ? extraStyles.container || {} : {})
                        }),
                        control: (provided,state) => ({
                            ...provided,
                            textAlign: 'left',
                            border: 'none',
                            borderRadius: 0,
                            padding: 0,
                            fontWeight: '500',
                            margin: '0',
                            height: '29px',
                            minHeight: 'none',
                            fontSize: '18px',
                            fontFamily: `"Poppins", sans-serif`,
                            boxShadow: 'none',
                            outline: 'none',
                            backgroundColor: '#fff',
                            '>div': {
                                padding: 0,
                                height: '29px',
                                minHeight: 'none',
                                alignItems: 'stretch',
                                lineHeight: '29px'
                            },
                            ...(extraStyles ? extraStyles.control || {} : {})
                        }),
                        indicatorSeparator: (provided,state) => ({
                            ...provided,
                            width: 0
                        }),
                        indicatorsContainer: (provided,state) => ({
                            ...provided,
                            height: 29,
                            '>div': {
                                padding: '4px 8px'
                            },
                            ' svg': {
                                fill: '#196ea4'
                            },
                            ...(extraStyles ? extraStyles.indicatorsContainer || {} : {})
                        }),
                        input: (provided,state) => ({
                            ...provided,
                            '>div>input': {
                                padding: '0 2px!important'
                            }
                        }),
                        menu: (provided,state) => ({
                            ...provided,
                            minWidth: '100%',
                            margin: '0',
                            boxShadow: '0px 6px 32px rgba(0, 0, 0, 0.35)',
                            borderColor: '#F2F2F2',
                            borderRadius: '3px', 
                            padding: '10px',
                            maxHeight: "400px",
                            overflow: 'auto',
                            opacity: 1,
                            zIndex: 1000
                        }),
                        singleValue: (provided,state) => ({
                            ...provided,
                            color: state.isDisabled ? '#ADADAD' : '#474747!important',
                            ...(extraStyles ? extraStyles.singleValue || {} : {})
                        }),
                        option: (provided,state) => {
                            var color = {};
                            if (state.isDisabled) {
                                color = {color: '#ADADAD'}
                            }
                            return ({
                                ...color,
                                padding: '10px 17px',
                                borderTop: '1px solid transparent',
                                borderBottom: '1px solid transparent',
                                fontFamily: `"Poppins", sans-serif`,
                                fontSize: 14,
                                '&:hover': state.isDisabled ? {} : {
                                    borderColor: '#E4E4E4',
                                    backgroundColor: state.isSelected ? '#d0dee9' : '#F2F2F2',
                                    cursor: 'pointer',
                                },
                                backgroundColor: state.isDisabled ? '#fff' : (state.isSelected ? '#d0dee9' : (state.isFocused ? '#e7eef4' : '#fff')),
                            })
                        }
                    }
                }
            />
            {/* {
                this.props.mprdropDown ?
                    (<div className={["dropdown", "mpr_dropdown","w-100", "align-self-center"].join(" ")} ref={this.setWrapperRef}>
                        <div className={["dd-header",this.state.listOpen ? styles.open : ""].join(" ")} onClick={() => this.toggleList()}>
                            
                            <div className={[ styles.mprbtnOption, "", "w-100", style].join(" ")}>
                                    <span className={[styles.dropdownText, disabled ? styles.disabled : ''].join(" ")}> {this.props.title}</span>
                                    <span className={["float-right ml-2", this.state.listOpen ? styles.open : ""].join(" ")}>
                                        <i className={[styles.select_arrow,"fa fa-angle-down", this.state.listOpen ? styles.open : ""].join(" ")} aria-hidden="true"></i>
                                    </span>
                            </div>
                            
                        </div>
                        {this.state.listOpen && <ul className={["dropdown-menu", this.state.listOpen ? "show" : ""].join(" ")}>
                        {data.map((item,index) => (
                            <li className={["dropdown-item", data.length > 0 ? (data[index].disabled ? styles.disabled : "") : ""].join(" ")} key={index} onClick={()=>{this.props.callBack(item); this.setState({listOpen: false})}} >{item.text || item}</li>
                        ))}
                        </ul>}
                    </div>)
                :
                    (<div className={["dropdown", "mpr_dropdown"].join(" ")} ref={this.setWrapperRef}>
                        <div className={["dd-header",this.state.listOpen ? styles.open : ""].join(" ")} onClick={() => this.toggleList()}>
                            
                            <div className={[styles.btnOption, "btn", "w-100", "m-0", showBorder && styles.borderBtm].join(" ")}>
                                <div className="row align-items-center">
                                    <span className={["col-9"].join(" ")}>
                                        {this.props.title}
                                        {
                                            this.props.price &&
                                            <img className={[styles.select_arrow, this.state.listOpen ? styles.open : ""].join(" ")} src={rigtharrow}/>
                                        }
                                    </span>
                                    {
                                        !this.props.price ?
                                        <span className={["col-3", "text-right", this.state.listOpen ? styles.open : ""].join(" ")}><img className={[styles.select_arrow, this.state.listOpen ? styles.open : ""].join(" ")} src={rigtharrow}/></span>
                                        :
                                        <span className={["col-3" , styles.price, "text-right"].join(" ")}>Rs. {decimal(this.props.price)}</span>
                                    }
                                </div>
                            </div>
                            
                        </div>
                        {this.state.listOpen && <ul className={["dropdown-menu", this.state.listOpen ? "show" : ""].join(" ")}>
                        {data.map((item,index) => (
                            <li className={["dropdown-item", data.length > 0 ? (data[index].disabled ? styles.disabled : "") : ""].join(" ")} key={item.id} onClick={()=>{this.props.callBack(item); this.setState({listOpen: false})}} >{item.text}</li>
                            ))}
                        </ul>}
                    </div>)
            } */}
            </>

        )
    }
}


export default SelectDropDown